import { SnackbarProvider as SnackbarProviderNotistack, closeSnackbar } from "notistack";
import { Outlet } from "react-router-dom";
import { ReactElement } from "react";
import { IconButton } from "@mui/material";
import { X } from "lucide-react";

interface SnackbarProviderProps {
    children?: ReactElement;
}

function SnackbarProvider({ children }: SnackbarProviderProps) {
    return (
        <SnackbarProviderNotistack
            maxSnack={5}
            preventDuplicate
            autoHideDuration={3000}
            action={(snackbarId) => (
                <IconButton size="small" onClick={() => closeSnackbar(snackbarId)} color="inherit">
                    <X size={16} />
                </IconButton>
            )}
        >
            {children}
            <Outlet />
        </SnackbarProviderNotistack>
    );
}

export default SnackbarProvider;
